import React from 'react'
import { Typography, Box } from '@mui/material'

const AdminDashboardPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Admin Dashboard
      </Typography>
      <Typography variant="body1">
        This page will display administrative overview and key metrics.
      </Typography>
    </Box>
  )
}

export default AdminDashboardPage
